import { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';

import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Box from '@mui/joy/Box';

import useFHRequestMessage from 'hooks/useFHRequestMessage';
import { FHRequestMessageType } from 'stores/fhrequest_message_store';
import ChatBubble from 'components/ChatBubble';
import { getIcon } from 'utils/misc';

import useUserIdentity from 'hooks/useUserIdentity';
import useFileAssociation from 'hooks/useFileAssociation';
import { FHRequestType } from 'stores/fhrequest_store';

function MessageItem({ message }: { message: FHRequestMessageType }) {
    const { fetchListByAssociation, getListByAssociation, items } = useFileAssociation();
    const [fileAssociations, setFileAssociations] =
        useState(getListByAssociation('request_message', message.uuid));
    const { currentIdentity } = useUserIdentity();
    const [fetched, setFetched] = useState(false);

    useEffect(() => {
        if(fetched) {
            console.log(`Let's not do this 1000 times for ${message.uuid}`);
            return;
        }
        fetchListByAssociation(currentIdentity?.key, "request_message", message.uuid)
            .then((fetchedItems) => {
                // console.log("Fetched items", fetchedItems);
                setFetched(true);
                setFileAssociations(fetchedItems);
            });
    }, [message.uuid]);

    useEffect(() => {
        setFileAssociations(getListByAssociation('request_message', message.uuid));
        //        console.log("File association items", items);
    }, [items.length]);

    //    console.log("trying to render chat bubble for", message.uuid);
    return (
        <ChatBubble
            uuid={message.uuid}
            file_associations={fileAssociations}
            sender={message.sender}
            identityKey={message.identity}
            original_content={message.original_content}
            content={message.content}
            content_type={message.content_type}
            date_created={message.date_created}
        />
    );
}

const RequestMessages = observer(({request}: {request: FHRequestType}) => {

    const { currentIdentity } = useUserIdentity();
    const { fetchListByRequest, getListByRequest } = useFHRequestMessage();
    const [fetched, setFetched] = useState(false);
    // const [messages, setMessages] = useState(getListByRequest(requestKey));
    //    const [firstLoad, setFirstLoad] = useState(true);
    const belowTheMessages = useRef<HTMLDivElement>(null);
    const CheckIcon = getIcon('Check');

    const messages = getListByRequest(request.uuid, request.ogkey);

    // useEffect(() => {
    //     if (messages.length) {
    //         //            if (!firstLoad) {
    //             belowTheMessages.current?.scrollIntoView({
    //                 behavior: "smooth",
    //                 block: "end",
    //             });
    //         // }
    //         //      setFirstLoad(false);
    //     }
    // }, [messages.length]);

    useEffect(() => {
        if (fetched) return;
        if (!currentIdentity?.key) return;
        setFetched(true);
        if (request.key) {
            fetchListByRequest(currentIdentity?.key, request.key).then(() => {
                console.log("Loaded messages!");
            });
        }

    }, [fetched, setFetched, fetchListByRequest, getListByRequest, currentIdentity?.key]);

    // useEffect(() => {
    //     // setMessages(getListByRequest(requestKey));
    // }, [getListByRequest, items.length]);

    console.log("Messages", messages);
    console.log("Messages length", messages.length);

    return (
        <Stack
            spacing={5}
            padding={1}
            mt={5}>
            {messages.map((message) => <MessageItem key={message.uuid} message={message} />)}

            { messages.length > 1 &&
            <Box sx={{ p: 8 }} ref={belowTheMessages}>
                <Stack
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}>
                    <Typography
                        startDecorator={<CheckIcon />}
                        level="body-xs">
                        That's it!
                    </Typography>
                </Stack>
            </Box>
            }
        </Stack>
    );
});

export default RequestMessages;
